<template>
  <comHeader></comHeader>
        <!-- inner banner -->
    <div class="inner-banner">
        <section class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">About Us</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">Home</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>About Us</li>
                </ul>
            </div>
        </section>
    </div>
    <!-- //inner banner -->

    <section class="w3l-about-2 py-5">
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
                <!-- col-lg-6 about-2-secs-left pr-lg-5 -->
                <div class="about-2-secs-left pr-lg-5">
                    <div class="about-logo">
                        <img src="@/assets/logo.png" style="width:100%;height:100%" alt="Sunray mascota Logo"> 
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2">Brand Story</h3>
                    <p>Every pet is a member of the family.</p>
                    <p>But globally, more than tens of millions of pets are lost every year, and most of them don't make it home simply because they have “no identity”.</p>
                    <p>Several members of our team have experienced the anxiety and helplessness of a lost pet, and this experience got us thinking:</p>
                    <p>Wouldn't the world be safer for pets if they had digital identities?</p>
                    <p>So we created this company - Let “pets have ID, there is a way back”.</p>
                    <p>Combined with our years of technical accumulation in NFC, QR code, Internet and other fields, we have created a complete set of pet identification and retrieval system, which not only helps owners to quickly retrieve their pets, but also pushes the pet industry towards a smarter, safer and more sustainable future.
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">Brand Vision</h3>
                    <p>
                        Let every pet have a digital identity, the road home is no longer far.
                        We hope to build a globally interconnected pet identity network that
                        so that pets have the right to be recognized, respected and guarded.
                        We also want to make the relationship between humans and pets more trusting, transparent and warm.

                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">Brand Mission</h3>
                    <p>
                        Provide reliable identification and security for pets through technology.
                        Provide pet owners with efficient and safe recovery solutions.
                        Provide partners with stable, safe and expandable pet ID system solutions.
                        Promote the digital transformation of the pet industry and improve the industry standard and user experience.
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">Brand Values</h3>
                    <p>
                        Security - Encrypted pet data management, privacy control, and quick response to retrieve lost data.
                        Trust--Build a two-way trust mechanism between pets and owners, and between brands and users.
                        Temperature - focusing on the life journey of each pet, turning cold technology into warm guarding
                        Openness and Collaboration--Cooperate with global brands, platforms and organizations to promote ecological co-construction.
                        Sustainability - Create a long-term, iterative product system to support global deployment and development.
                    </p>
                </div>
            </div>
        </div>
    </section>
  </template>
  <script>
  import comHeader from '../components/comHeader.vue';

  export default {
    name: 'appAbout',
    components:{
      comHeader
    }
  }
  </script>
  
  <style>
  /* 可添加样式 */
  .title{
    margin-top: 40px;
  }
  .flex-direction{
    flex-direction:column
  }
  .about-logo {
      float: right;
      margin: 15px 0 20px 20px;
      width: 200px;
    }
  </style>